<script>
/* Note that this creates / updates an account request and so can be used at the end of an onboard request */
import { mapActions } from 'vuex'
import { getCurrentOnBoardRequest, updateCurrentOnBoardRequest } from '@/onBoardRequest'

export default {
  name: 'BillingInfo',
  props: {
    trackName: String,
    helpEmail: {
      type: String,
      default: 'rchelp@rc.fas.harvard.edu',
    },
  },
  data: function () {
    return {
      stepName: 'billing_contact_collected',
      loading: false,
      isValid: false,
      onBoardRequest: {},
      organizations: [],
      otherAffiliations: [],
      search: '',
      emailRules: [(v) => !!v || 'E-mail is required', (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'],
      file: {
        name: '',
        data: '',
        stepName: '',
        trackName: '',
      },
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    onFocus() {
      this.$refs.orgSelect.isMenuActive = true
    },
    resetForm() {
      this.$refs.billingContactForm.reset()
    },
    submit() {
      this.onBoardRequest.setTrackStepComplete(this.trackName, this.stepName)
      const me = this
      updateCurrentOnBoardRequest(me.onBoardRequest)
        .then(async () => {
          this.$api.mountNextComponent(me.onBoardRequest)
        })
        .catch(error => {
          const { response } = error
          if (response) {
            this.errors = response.data
          }
          if (response.status !== 400) {
            this.showMessage(error)
          }
        });
    },
  },
  mounted: function () {
    const me = this
    getCurrentOnBoardRequest()
      .then((res) => {
        me.onBoardRequest = res
        if (!me.onBoardRequest.billingContact) {
          me.$set(me.onBoardRequest, 'billingContact', {
            name: '',
            email: '',
          })
        }
      })
      .catch((error) => me.showMessage(error))

    this.loading = true

    this.file.stepName = this.stepName;
    this.file.trackName = this.trackName;
  },
}
</script>
<template>
  <v-row justify="space-between" fill-height>
    <v-col class="lg-inner">
      <h1>Billing Contact</h1><p>&nbsp;</p>
      <p>Provide contact information for individual responsible for billing.</p>
      <v-form id="billing-contact-form" ref="billingContactForm" v-model="isValid" @submit.prevent="submit">
        <v-row class="ma-1">
          <v-col class="ma-1">
            <v-text-field
              v-model="onBoardRequest.billingContact.name"
              label="Name"
              color="secondary"
              ref="contactName"
              required
              class="required"
            >
            </v-text-field>
          </v-col>
          <v-col class="ma-1">
            <v-text-field
              v-model="onBoardRequest.billingContact.email"
              label="Email"
              color="secondary"
              ref="contactEmail"
              :rules="emailRules"
              required
              class="required"
              >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="ma-1 pa-6">
            <v-textarea
              v-model="onBoardRequest.billingContact.address"
              label="Address"
              color="secondary"
              ref="contactAddress"
              rows="4"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row class="ma-1">
          <v-col class="ma-1">
            <v-btn class="btn" :disabled="!isValid" color="secondary" type="submit" form="billing-contact-form">Next</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>
<style lang="css" scoped>
.text-block {
  margin: 1rem 0;
}
.text-hint {
  margin-top: 2rem;
}
.text-action {
  margin-bottom: 1rem;
}
#billing-contact-form {
  margin-top: 1rem;
}
</style>
